import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, Fragment as _Fragment, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-680b18aa"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-egg-basket" }, null, -1))
const _hoisted_2 = { class: "col-md-9" }
const _hoisted_3 = {
  key: 0,
  class: "coverage-column w-100 mb-30"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label label_danger pdl-40 pdr-40 sm-pdr-10 sm-pdl-10" }, " Pension Payments on Hold - Please Call Us at 800-456-3863 ", -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "fund-cover-header" }
const _hoisted_7 = { class: "fund-cover-row" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-clipboard-tick" }, null, -1))
const _hoisted_9 = { class: "links" }
const _hoisted_10 = { class: "tooltip-wrapper" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-square-info icon_rotate_0" }, null, -1))
const _hoisted_12 = { class: "tooltip-text tooltip-text_secondary tooltip-text__xlarge card-body d-flex flex-column gap-4 sm-fs-xxs" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "text-white" }, "I.A.T.S.E. NATIONAL PENSION FUND", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " This Pension Credit History & Estimated Benefit Statement is based upon current Plan provisions and benefit levels and the service data in the Fund’s records at the time of your request. It is an estimate for your general information only. The information has not been verified and does not necessarily mean that you have a vested benefit. Your actual entitlement to benefits will, of course, depend upon the final components of the calculation, such as, for example, your years of service, age, marital status and the form in which you elect to receive your benefits when you are eligible to receive them. ", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " The Trustees reserve the right to correct any discrepancies in this estimate. Only the full Board of Trustees of the Plan has the authority to make a definite, official determination of your status and to approve or deny an application for benefits. ", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", null, "If you believe you are entitled to credit for work that is not reflected in the Fund’s records, it is your responsibility to provide documentation supporting that claim.")
], -1))
const _hoisted_17 = ["href"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " If there is a discrepancy between the Rules and Regulations of the Plan, the Summary Plan Description and the information contained in this statement, the provisions contained in the Rules and Regulations of the Plan will govern. ", -1))
const _hoisted_19 = { key: 0 }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1))
const _hoisted_21 = { class: "coverage-column" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fund-cover-row" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-trade" }),
  /*#__PURE__*/_createElementVNode("p", { class: "links" }, "Pension Credits:")
], -1))
const _hoisted_23 = { class: "" }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { key: 1 }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "tooltip-wrapper" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-info-tooltip icon_rotate_0" }),
  /*#__PURE__*/_createElementVNode("p", { class: "tooltip-text tooltip-text_secondary" }, " Click the ‘Pension Credit History’ button to submit a request to the Fund Office for a Pension Credit History Report. ")
], -1))
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1))
const _hoisted_29 = { class: "fund-cover-row" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-trade" }, null, -1))
const _hoisted_31 = { class: "links" }
const _hoisted_32 = {
  key: 0,
  class: "tooltip-wrapper"
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-info-tooltip icon_rotate_0" }, null, -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "tooltip-text tooltip-text_secondary" }, " Click the ‘Pension Credit History’ button to submit a request to the Fund Office for a Pension Credit History Report. ", -1))
const _hoisted_35 = [
  _hoisted_33,
  _hoisted_34
]
const _hoisted_36 = { class: "" }
const _hoisted_37 = { key: 0 }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, null, -1))
const _hoisted_39 = {
  key: 0,
  class: "divider"
}
const _hoisted_40 = {
  key: 1,
  class: "coverage-column gap-0 sm-gap-10 align-items-md-center align-items-start"
}
const _hoisted_41 = { class: "fund-cover-row col-md-5 justify-content-start" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-map" }, null, -1))
const _hoisted_43 = {
  key: 1,
  class: "info_card info_card__danger mb-30 ml-10",
  style: {"max-width":"50%"}
}
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " The Pension Credits History page is currently under maintenance. We apologize for the inconvenience. If you need your Pension Credits History while the page is unavailable, please contact the Fund Office for assistance. ", -1))
const _hoisted_45 = [
  _hoisted_44
]
const _hoisted_46 = { class: "fund-cover-buttons" }
const _hoisted_47 = ["aria-disabled"]
const _hoisted_48 = ["aria-disabled"]
const _hoisted_49 = ["aria-disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FundPanel = _resolveComponent("FundPanel")!

  return (_openBlock(), _createBlock(_component_FundPanel, {
    cardId: "card-pension",
    alerts: _ctx.alerts
  }, {
    icon: _withCtx(() => [
      _hoisted_1
    ]),
    title: _withCtx(() => [
      _createTextVNode(" Pension ")
    ]),
    "fund-cover": _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: _normalizeClass(["fund-cover fund-cover__pension", { 'pdt-30 pdb-30': _ctx.isPensioner }])
        }, [
          (_ctx.hasPaymentsOnHold)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", {
              class: _normalizeClass(["coverage-column", { 'flex-grow-1': _ctx.isPensioner }])
            }, [
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _createElementVNode("p", _hoisted_9, [
                  _createTextVNode("Pension Benefit Status: "),
                  _createElementVNode("span", _hoisted_10, [
                    _hoisted_11,
                    _createElementVNode("div", _hoisted_12, [
                      _hoisted_13,
                      _hoisted_14,
                      _hoisted_15,
                      _hoisted_16,
                      _createElementVNode("span", null, [
                        _createTextVNode(" This statement does not in any way modify the Rules and Regulations of the Plan, including but not limited to the rules concerning vesting and breaks in service. Your Summary Plan Description booklet contains a summary of the Rules and Regulations and should be referred to for a general description of Plan provisions including but not limited to how benefit credits are earned and the eligibility rules for receiving Pension benefits. Other important Plan features such as the Husband & Wife election/waiver, early retirement rules, etc. are also described therein. If you do not have a Plan booklet, you can obtain one by writing to the Pension Fund Office at the address below, by calling us at 1-800-456-FUND (3863), or by visiting our website at "),
                        _createElementVNode("a", {
                          href: _ctx.baseUrl,
                          target: "_blank",
                          class: "text-white"
                        }, "www.iatsenbf.org", 8, _hoisted_17),
                        _createTextVNode(". ")
                      ]),
                      _hoisted_18
                    ])
                  ])
                ])
              ]),
              _createElementVNode("p", null, [
                _createElementVNode("strong", null, _toDisplayString(_ctx.loading ? '...' : _ctx.status), 1),
                (_ctx.isPensioner)
                  ? (_openBlock(), _createElementBlock("small", _hoisted_19, _toDisplayString(_ctx.loading ? '' : _ctx.date), 1))
                  : _createCommentVNode("", true)
              ])
            ], 2),
            _hoisted_20,
            _createElementVNode("div", _hoisted_21, [
              _hoisted_22,
              _createElementVNode("p", _hoisted_23, [
                (_ctx.creditsUnderMaintenance)
                  ? (_openBlock(), _createElementBlock("strong", _hoisted_24, "Temporarily unavailable"))
                  : (_ctx.mode === _ctx.PensionMode.SUBMISSION)
                    ? (_openBlock(), _createElementBlock("strong", _hoisted_25, _hoisted_27))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                        _createElementVNode("strong", null, _toDisplayString(_ctx.loading ? '...' : _ctx.pensionCredits), 1),
                        _createElementVNode("small", null, _toDisplayString(_ctx.loading ? '' : _ctx.date), 1)
                      ], 64))
              ])
            ]),
            _hoisted_28,
            _createElementVNode("div", {
              class: _normalizeClass(["coverage-column", { 'mt-30 sm-mt-10': _ctx.isPensioner }])
            }, [
              _createElementVNode("div", _hoisted_29, [
                _hoisted_30,
                _createElementVNode("p", _hoisted_31, [
                  _createTextVNode("Vested Credits: "),
                  (_ctx.mode === _ctx.PensionMode.SUBMISSION)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_32, _hoisted_35))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("p", _hoisted_36, [
                (_ctx.creditsUnderMaintenance)
                  ? (_openBlock(), _createElementBlock("strong", _hoisted_37, "Temporarily unavailable"))
                  : (_ctx.mode === _ctx.PensionMode.SUBMISSION)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _hoisted_38,
                        _createElementVNode("small", null, _toDisplayString(_ctx.loading ? '' : ''), 1)
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                        _createElementVNode("strong", null, _toDisplayString(_ctx.loading ? '...' : _ctx.vestedCredits), 1),
                        _createElementVNode("small", null, _toDisplayString(_ctx.loading ? '' : _ctx.date), 1)
                      ], 64))
              ])
            ], 2),
            (_ctx.isPensioner)
              ? (_openBlock(), _createElementBlock("div", _hoisted_39))
              : _createCommentVNode("", true),
            (_ctx.isPensioner)
              ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                  _createElementVNode("div", _hoisted_41, [
                    _hoisted_42,
                    _createElementVNode("p", {
                      class: "plan-modal links text-underline sm-fs-sm",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openModal('check-destination', 'Payment Destination Setup', 'plan-form', 'pension')))
                    }, " Pension Check Destination: ")
                  ]),
                  _createElementVNode("p", null, [
                    _createElementVNode("strong", null, _toDisplayString(_ctx.checkDestination ?? '-'), 1)
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          (_ctx.creditsUnderMaintenance)
            ? (_openBlock(), _createElementBlock("div", _hoisted_43, _hoisted_45))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_46, [
            _createElementVNode("a", {
              href: "",
              class: _normalizeClass(["btn btn-primary plan-modal", { 'mr-20 sm-mr-0': _ctx.isPensioner }]),
              onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.openModal('work-history', 'Pension Work History', null, 'pension', null, null, undefined, { Funds: [1, 2, 9] })), ["prevent"]))
            }, " Work History ", 2),
            (_ctx.mode === _ctx.PensionMode.SUBMISSION)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  href: "",
                  class: "btn btn-secondary plan-modal mr-20 sm-mr-0",
                  "aria-disabled": !_ctx.mode,
                  onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (
                                _ctx.openModal(
                                    'request-pch',
                                    'Pension Credits History Request Confirmation',
                                    'plan-profile plan-tables pension-credits',
                                    'pension',
                                    null,
                                    'Pension Credit History'
                                )
                            ), ["prevent"]))
                }, " Pension Credit History ", 8, _hoisted_47))
              : (_ctx.isPensioner)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 1,
                    href: "",
                    class: _normalizeClass(["btn btn-secondary plan-modal mr-20 sm-mr-0", { disabledcredit: _ctx.creditsUnderMaintenance }]),
                    "aria-disabled": _ctx.creditsUnderMaintenance || !_ctx.mode,
                    onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (
                                !_ctx.creditsUnderMaintenance &&
                                _ctx.openModal(
                                    'pension-credits-history',
                                    'Pension',
                                    'plan-profile plan-tables pension-credits',
                                    'pension',
                                    null,
                                    'Pension Credit History'
                                )
                            ), ["prevent"]))
                  }, " Pension Credit History ", 10, _hoisted_48))
                : (_openBlock(), _createElementBlock("a", {
                    key: 2,
                    href: "",
                    class: _normalizeClass(["btn btn-secondary plan-modal mr-20 sm-mr-0", { disabledcredit: _ctx.creditsUnderMaintenance }]),
                    "aria-disabled": _ctx.creditsUnderMaintenance || !_ctx.mode,
                    onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (
                                !_ctx.creditsUnderMaintenance &&
                                _ctx.openModal(
                                    'pension-credits-history',
                                    'Pension Credit History',
                                    'plan-profile plan-tables pension-credits',
                                    'pension'
                                )
                            ), ["prevent"]))
                  }, " Pension Credit History ", 10, _hoisted_49)),
            (_ctx.isPensioner)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 3,
                  href: "",
                  class: "btn btn-secondary plan-modal",
                  onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.openModal(
                            'pensioner-profile', 'Pension', 'plan-profile plan-tables pension-credits', 'pension', null, 'Pensioner Profile',
                            [{
                                name: 'View Pension Credit History', title: 'Pension > Pensioner Profile', secondTitle: 'Pension Credit History',
                                    action: 'pension-credits-history', classes: 'plan-profile plan-tables pension-credits',
                                    type: 'secondary'
                                }, {
                                name: 'Work History', title: 'Pension > Pensioner Profile', secondTitle: 'Pension Work History', action: 'work-history', classes: '', queryParams: { Funds: [1, 2, 9] },
                                type: 'secondary'
                            }])), ["prevent"]))
                }, " View Profile "))
              : _createCommentVNode("", true)
          ])
        ], 2)
      ])
    ]),
    "related-links": _withCtx(() => [
      (_ctx.isPensioner)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("button", {
              class: "btn btn-tertiary btn-large plan-modal",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.openModal('check-destination', 'Payment Destination Setup', 'plan-form', 'pension')))
            }, " ACH/Check Destination"),
            (_ctx.hasChecks)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "btn btn-tertiary btn-large plan-modal",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.openModal('check-replacement', 'Check Replacement', 'plan-form', 'pension')))
                }, " Check Replacement "))
              : _createCommentVNode("", true)
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("a", {
              href: "",
              class: "btn btn-tertiary btn-large plan-modal",
              onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (_ctx.openModal('pension-application', 'Pension Application', 'plan-form', 'application')), ["prevent"]))
            }, "Pension Application "),
            _createElementVNode("a", {
              href: "",
              class: "btn btn-tertiary btn-large plan-modal",
              onClick: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (_ctx.openModal('pension-application', 'Estimate Request', 'plan-form', 'estimate')), ["prevent"]))
            }, " Estimate Request ")
          ], 64)),
      _createElementVNode("a", {
        href: "",
        class: "btn btn-tertiary btn-large plan-modal",
        onClick: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (_ctx.openModal('add-beneficiary',
                'My Beneficiary(ies)',
                'plan-tables-striped beneficiary',
                null,
                null,
                null,
            )), ["prevent"]))
      }, " Beneficiary(ies) "),
      _createElementVNode("a", {
        href: "",
        onClick: _cache[11] || (_cache[11] = _withModifiers(($event: any) => (_ctx.openModal('plan-resources', 'Pension Fund Resources', null, 'pension')), ["prevent"])),
        class: "btn btn-tertiary btn-large plan-modal"
      }, "Fund's Resources")
    ]),
    _: 1
  }, 8, ["alerts"]))
}